export function getNameInitials(name: string, separator = '. ') {
    const parts = name.split(' ').filter((s) => s !== '');

    return parts.length === 0
        ? ''
        : parts.reduce((previous, current) => `${previous}${current[0].toUpperCase()}${separator}`, '').trim();
}
